
import React from 'react';
import AnimateVeoIcon from './AnimateVeoIcon';
import AnimateVeoAudioIcon from './AnimateVeoAudioIcon';
import ChangeBackgroundIcon from './ChangeBackgroundIcon';
import PhotorealismIcon from './PhotorealismIcon';
import ImFeelingLuckyIcon from './ImFeelingLuckyIcon';

export type ImageQuickActionType =
  | 'animate-veo'
  | 'animate-veo-audio'
  | 'change-background'
  | 'photorealism'
  | 'im-feeling-lucky';

interface ImageQuickActionToolbarProps {
  onQuickAction: (action: ImageQuickActionType, label: string) => void; 
  disabled?: boolean;
  onDebugHover?: (name: string | null) => void; // New prop
}

const ImageQuickActionToolbar: React.FC<ImageQuickActionToolbarProps> = ({ onQuickAction, disabled, onDebugHover }) => {
  const quickActions = [
    { type: 'animate-veo', icon: <AnimateVeoIcon />, label: 'Animar con Veo3', colorClassName: 'text-cyan-400' },
    { type: 'animate-veo-audio', icon: <AnimateVeoAudioIcon />, label: 'Animar con Audio en Veo3', colorClassName: 'text-blue-400' },
    { type: 'change-background', icon: <ChangeBackgroundIcon />, label: 'Cambiar Fondo', colorClassName: 'text-lime-400' },
    { type: 'photorealism', icon: <PhotorealismIcon />, label: 'Aplicar Fotorealismo', colorClassName: 'text-orange-400' },
    { type: 'im-feeling-lucky', icon: <ImFeelingLuckyIcon />, label: "Voy a Tener Suerte (Regenerar)", colorClassName: 'text-purple-400' },
  ];

  return (
    <div className="flex flex-col space-y-1 p-1 bg-emerald-800 bg-opacity-85 rounded-lg shadow-lg ring-1 ring-emerald-600">
      {quickActions.map(actionDef => (
        <button
          key={actionDef.type}
          onClick={() => onQuickAction(actionDef.type as ImageQuickActionType, actionDef.label)} 
          onMouseEnter={() => onDebugHover?.(`Quick Toolbar Action: ${actionDef.label}`)}
          onMouseLeave={() => onDebugHover?.(null)}
          disabled={disabled}
          className="p-2 group rounded-md transition-colors focus:outline-none focus:ring-1 focus:ring-indigo-400 disabled:opacity-40 disabled:cursor-not-allowed"
          aria-label={actionDef.label}
          title={actionDef.label}
        >
          {React.cloneElement(actionDef.icon, {
            className: `w-6 h-6 ${actionDef.colorClassName} group-hover:opacity-80 transition-opacity`
          })}
        </button>
      ))}
    </div>
  );
};

export default ImageQuickActionToolbar;
